import { isEmpty, mapValues } from 'lodash';

import { PERFORMANCE_EXTRACTION_STATUS, VISIBLE_RESOURCES_STATUSES } from 'src/data/performance';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { PerformanceStore } from 'src/store';

const usePerformanceState = createStateSelectorHook(PerformanceStore, ['userAccountsMap']);

const CHANNEL_ACCOUNT_STATUS = {
  connectedAccounts: VISIBLE_RESOURCES_STATUSES,
  disconnectedAccounts: [
    PERFORMANCE_EXTRACTION_STATUS.disconnected,
    PERFORMANCE_EXTRACTION_STATUS.doneWithErrors,
    PERFORMANCE_EXTRACTION_STATUS.nullableResults,
  ],
  processingAccounts: [PERFORMANCE_EXTRACTION_STATUS.processing],
};

export const useUserChannelAccounts = () => {
  const { userAccountsMap } = usePerformanceState();

  if (isEmpty(userAccountsMap)) {
    return mapValues(CHANNEL_ACCOUNT_STATUS, () => ({}));
  }

  return Object.keys(CHANNEL_ACCOUNT_STATUS).reduce((statusAcc, status) => {
    const channels = Object.keys(userAccountsMap || {});
    const accountsPerStatus = { ...statusAcc };

    channels.forEach((channel) => {
      if (!accountsPerStatus[status]) {
        accountsPerStatus[status] = {};
      }

      accountsPerStatus[status][channel] = (userAccountsMap[channel] || []).filter((account) =>
        CHANNEL_ACCOUNT_STATUS[status].includes(account.status)
      );
    });

    return accountsPerStatus;
  }, {});
};
